import { createSupportInstances, SupportUI, FilterType } from "./supportUI";

class Support {
  public constructor(private ui: SupportUI) {
    this.ui.onFilter(this.handleFilter.bind(this))
  }

  public handleFilter(filter: FilterType) {
    this.ui.toggleTableRows(filter);
  }
}

export function initSupport() {
  return createSupportInstances().map((ui: SupportUI) => {
    return new Support(ui);
  });
}
